import loggingService from '../services/util/loggingService'
import dateService from '../services/util/dateService'
import mediaService from '@/services/mediaService'

var isDebug = false
var path = '/RadioCarbonReport/'

function get (http, id) {
    return http.get(`${path}Get?radioCarbonReportId=${id}`)
}

function put (http, dto) {
    return http.put(path, dto)
}

function remove (http, id) {
    return http.post(`${path}Remove?radioCarbonReportId=${id}`)
}

function removeByMediaId (http, id) {
    return http.post(`${path}RemoveByMediaId?mediaId=${id}`)
}

function search (http, searchDto) {
    loggingService.log(isDebug, 'Radio Carbon Service ', 'Search by ' + searchDto.culturalResourceId)
    return http.post(`${path}Search`, searchDto).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.reportDate = dateService.convertToDate(x.reportDate)
            })
        }
        return response
    })
}

function todo (http, searchDto) {
    loggingService.log(isDebug, 'Radio Carbon Service ', 'Todo ' + searchDto.culturalResourceId)
    return http.post(`${path}Todo`, searchDto).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.reportDate = dateService.convertToDate(x.reportDate)
            })
        }
        return response
    })
}

function linkMediaFile (http, radioCarbonReportId, crrMediaId) {
    return http.put(`${path}LinkMediaFile?radioCarbonReportId=${radioCarbonReportId}&crrMediaId=${crrMediaId}`)
}

function saveNewRadioCarbon (http, radioCarbonReportDto, mediaTypeId, mediaSubtypeId, parentId, fileToUpload, comment) {
    return mediaService.putFile(http, mediaTypeId, mediaSubtypeId, parentId, fileToUpload, comment).then(result => {
        if (result.data) {
            radioCarbonReportDto.CulturalResourceRecordingMediaId = result.data.id
            return http.put(`${path}`, radioCarbonReportDto)
        }
    })
}

function getRadioCarbonSampleTypeList () {
    return [
        { radioCarbonSampleTypeId: 1, description: 'Charcoal' },
        { radioCarbonSampleTypeId: 2, description: 'Wood' },
        { radioCarbonSampleTypeId: 3, description: 'Bone' },
        { radioCarbonSampleTypeId: 4, description: 'Animal' },
        { radioCarbonSampleTypeId: 5, description: 'Insect' },
        { radioCarbonSampleTypeId: 6, description: 'Leather' },
        { radioCarbonSampleTypeId: 7, description: 'Peat' },
        { radioCarbonSampleTypeId: 8, description: 'Pollen' },
        { radioCarbonSampleTypeId: 9, description: 'Seeds' },
        { radioCarbonSampleTypeId: 10, description: 'Teeth' },
        { radioCarbonSampleTypeId: 11, description: 'Shell' },
        { radioCarbonSampleTypeId: 12, description: 'Pottery Residue' },
        { radioCarbonSampleTypeId: 13, description: 'Sediment' },
        { radioCarbonSampleTypeId: 14, description: 'Soil' },
        { radioCarbonSampleTypeId: 15, description: 'Textile' },
        { radioCarbonSampleTypeId: 16, description: 'Other' }
    ]
}

function getBoneDateTypeList () {
    return [
        { boneDateTypeId: 1, description: 'Burnt' },
        { boneDateTypeId: 2, description: 'Amino Acid' },
        { boneDateTypeId: 3, description: 'Purified' },
        { boneDateTypeId: 4, description: 'Apatite' },
        { boneDateTypeId: 5, description: 'Collagen' },
        { boneDateTypeId: 6, description: 'Other' },
        { boneDateTypeId: 7, description: 'Unknown' }
    ]
}

function getAnthropogenicCertaintyList () {
    return [
        { anthropogenicCertaintyId: 1, description: 'Low' },
        { anthropogenicCertaintyId: 2, description: 'Medium' },
        { anthropogenicCertaintyId: 3, description: 'High' }
    ]
}

function getHumanEventCertaintyList () {
    return [
        { humanEventCertaintyId: 1, description: 'Low' },
        { humanEventCertaintyId: 2, description: 'Medium' },
        { humanEventCertaintyId: 3, description: 'High' }
    ]
}

function getDatingMethodList () {
    return [
        { datingMethodId: 1, description: 'Radiometric' },
        { datingMethodId: 2, description: 'AMS' }
    ]
}

export default {
    get: get,
    put: put,
    remove: remove,
    search: search,
    getRadioCarbonSampleTypeList: getRadioCarbonSampleTypeList,
    getBoneDateTypeList: getBoneDateTypeList,
    getAnthropogenicCertaintyList: getAnthropogenicCertaintyList,
    getHumanEventCertaintyList: getHumanEventCertaintyList,
    getDatingMethodList: getDatingMethodList,
    linkMediaFile: linkMediaFile,
    removeByMediaId: removeByMediaId,
    todo: todo,
    saveNewRadioCarbon: saveNewRadioCarbon
}



// WEBPACK FOOTER //
// ./src/services/radioCarbonReportService.js